import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

const PrintDialog = () => {
    const print = React.useCallback(() => window.print(), []);
    React.useEffect(() => {
        window.onafterprint = () => window.close();
        window.print();
    }, []);
    return (
        <div className="text-center mt-5">
            <button type="button" className="btn btn-primary btn-lg" onClick={print}>
                <FormattedMessage {...messages.dashboard.buttons.print} />
            </button>
        </div>
    );
};

export default PrintDialog;
